import React, { forwardRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "./DataTable.css";
import 'ag-grid-enterprise';

// Use forwardRef to pass the ref to AgGridReact
const DataTable = forwardRef(({
  columns,
  rows,
  pagination,
  paginationPageSize,
  paginationPageSizeSelector,
  rowSelection,
  isRowSelectable,
  suppressRowClickSelection,
  onRowSelected,
  gridOptions,
  onGridReady,
  onPaginationChanged,
  onSelectionChanged,
  headerCheckboxSelectionFilterOnly,
  isCellCheckboxSelection,
  onFirstDataRendered,
  selectionColumnDef,
  getRowStyle,
  getRowId,
  cellEditorParams,
  stopEditingWhenCellsLoseFocus,
  onCellValueChanged,
  onFilterChanged,
  postFilterChanged,
  suppressMenuHide,
  tableHeight,
  tablewidth,
  suppressMovableColumns,
  suppressHorizontalScroll,
  cellMouseOver,
  suppressPaginationPanel,
  enableBrowserTooltips,
  suppressCsvExport,
  paginationAutoPageSize,
  singleClickEdit,
  getRowClass,
  autoGroupColumnDef,
  groupDefaultExpanded,
  headerHeight,
  noRowsOverlayComponent,
  noRowsOverlayComponentParams
}, ref) => {
  return (
    <div
      className="ag-theme-quartz"
      style={{ height: tableHeight, width: tablewidth }}
    >
      <AgGridReact
        ref={ref}
        rowData={rows}
        columnDefs={columns}
        pagination={pagination ?? true}
        paginationPageSize={paginationPageSize || 10}
        paginationPageSizeSelector={paginationPageSizeSelector || [10, 20, 30, 50, 100]}
        paginationAutoPageSize={paginationAutoPageSize}
        rowSelection={rowSelection || "multiple"}
        isRowSelectable={isRowSelectable}
        suppressRowClickSelection={suppressRowClickSelection ?? true}
        moveColumns={false}
        suppressDragLeaveHidesColumns={true}
        suppressMovable={true}
        onRowSelected={onRowSelected}
        gridOptions={gridOptions}
        onGridReady={onGridReady}
        onPaginationChanged={onPaginationChanged}
        onSelectionChanged={onSelectionChanged}
        headerCheckboxSelectionFilterOnly={headerCheckboxSelectionFilterOnly}
        isCellCheckboxSelection={isCellCheckboxSelection}
        onFirstDataRendered={onFirstDataRendered}
        selectionColumnDef={selectionColumnDef}
        getRowStyle={getRowStyle}
        getRowId={getRowId}
        getRowClass={getRowClass}
        cellEditorParams={cellEditorParams}
        stopEditingWhenCellsLoseFocus={stopEditingWhenCellsLoseFocus ?? true}
        onCellValueChanged={onCellValueChanged}
        onFilterChanged={onFilterChanged}
        postFilterChanged={postFilterChanged}
        suppressMenuHide={suppressMenuHide}
        suppressMovableColumns={suppressMovableColumns}
        suppressHorizontalScroll={suppressHorizontalScroll}
        cellMouseOver={cellMouseOver}
        suppressPaginationPanel={suppressPaginationPanel}
        enableBrowserTooltips={enableBrowserTooltips}
        suppressCsvExport={suppressCsvExport}
        singleClickEdit={singleClickEdit ?? true}
        autoGroupColumnDef={autoGroupColumnDef}
        groupDefaultExpanded={groupDefaultExpanded}
        headerHeight={headerHeight}
        noRowsOverlayComponent={noRowsOverlayComponent}
        noRowsOverlayComponentParams={noRowsOverlayComponentParams}
      />
    </div>
  );
});

export default DataTable;